import { createFileRoute } from "@tanstack/react-router";
import AdminActiveLocations from "@/pages/admin/AdminActiveLocations";

export const Route = createFileRoute("/admin/locales-activos")({
  component: AdminActiveLocations,
});
